<template>
    <div>
        <v-dialog v-model="showReceiptPaperModal" @close="close">
            <v-card tile>
                <v-toolbar height="55px" card dark class="blue-grey darken-2 white--text">
                    <v-btn icon dark @click="close">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Recibo {{selectedReceipt.code}}/{{selectedReceipt.series}}</v-toolbar-title>
                    <span v-if="isReceiptCanceled" style="margin-left: 10px; font-size: 20px; color: rgb(243, 99, 99);">Anulado</span>
                    <v-spacer></v-spacer>
                    <!--<span><span  class="green&#45;&#45;text text&#45;&#45;lighten-4"><b>Pago: {{selectedInvoice.pendent_value | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</b></span>-->
                        <!--<br><span v-if="getAlreadyPaid > 0">A pagar: {{getAlreadyPaid | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</span>-->
                    <!--</span>-->
                    <!--<v-layout row wrap color="success">-->
                    <!--<v-flex xs6>Pago</v-flex>-->
                    <!--<v-flex xs6>Por pagar</v-flex>-->
                    <!--</v-layout>-->
                </v-toolbar>
                <v-card-text>
                    <v-container fluid grid-list-md>
                        <v-layout row wrap justify-center>
                            <v-flex xs12 sm12 md8 lg7 justify-center>

                                <v-flex xs12>
                                    <v-card>
                                        <!--<v-toolbar card dark color="blue lighten-3">-->
                                            <!--<v-toolbar-title color="grey&#45;&#45;text">Recibo nº {{selectedReceipt.code}}/{{selectedReceipt.series}}</v-toolbar-title>-->
                                            <!--<v-spacer></v-spacer>-->
                                            <!--<v-chip ma-3 label outline color="yellow lighten-2">Rascunho</v-chip>-->
                                        <!--</v-toolbar>-->

                                        <!--Invoice-->

                                        <v-progress-linear
                                                color="indigo"
                                                v-if="loadingReceiptInvoices"
                                                :indeterminate=true
                                                height="2"
                                                value="15"
                                        ></v-progress-linear>

                                        <div id="fac" v-else ref="factura" style="font-family: sans-serif; margin: 8mm"
                                             :style="[isA5Format ? {'min-height': '190mm'} : {'min-height':'280mm'}]">

                                            <div v-if="isReceiptCanceled" style="position: absolute; left: 50%; top: 34%">
                                                <div style="position: relative; right: 50%; bottom: 66%; border:1px solid red; border-radius: 5px; padding: 5px;transform: rotate(-45deg); opacity: 0.4">
                                                    <span style="font-size: 32px; color: red">Documento Anulado</span>
                                                </div>
                                            </div>

                                            <table class="table table-bordered" border="0" width="60%" style="padding: 0; margin: 0; float: left">
                                                <tr>
                                                    <td rowspan="3" width="50%"  align="left" style="padding: 0; margin: 0;"
                                                        :style="[isA5Format ? {'font-size': '11px'} : {'font-size':'12px'}]"
                                                    >
                                                        <img :src="getCompanyLogo" style="height: 80px; margin-bottom: 5px"/>
                                                        <br>
                                                        <span v-if="getCompany().name">{{getCompany().name}}<br></span>
                                                        <span>NIF: {{getCompanyNif}}<br></span>
                                                        <span v-if="getCompanyAddress">{{getCompanyAddress}}<br></span>
                                                        <span v-if="getCompanyPhone">Tel: {{getCompanyPhone}}<br></span>
                                                        <span v-if="getCompanyEmail">Email: {{getCompanyEmail}}<br></span>
                                                        <span :style="[isA5Format ? {'font-size': '10px'} : {'font-size':'12px'}]"
                                                              v-if="getPrimaryNib">{{getPrimaryNib}}<br></span>
                                                        <span :style="[isA5Format ? {'font-size': '10px'} : {'font-size':'12px'}]"
                                                              v-if="getSecondNib">{{getSecondNib}}<br></span>

                                                    </td>
                                                </tr>
                                            </table>
                                            <table class="table table-bordered" :class="isA5Format ? 'a5format' : 'a4format'" border="0" width="33%" style="padding: 0; margin-top: 50px; float: right">
                                                <tr>
                                                    <td align="right" style="padding: 0; margin: 0;"
                                                        :style="[isA5Format ? {'font-size': '11px'} : {'font-size':'12px'}]"
                                                    >
                                                        <span :style="[isA5Format ? {'font-size': '11px'} : {'font-size':'14px'}]">
                                                            <b>Recibo Nº {{selectedReceipt.code}}/{{selectedReceipt.series}}</b>
                                                        </span>
                                                        <br><br>
                                                        <span>Exmo(a). Senhor(a)<br></span>
                                                        <span v-if="getClientName"><b>{{getClientName}}</b><br></span>
                                                        <span v-if="getClientNif">NIF: {{getClientNif}}<br></span>
                                                        <span v-if="getClientCity">Cidade: {{getClientCity}}<br></span>
                                                        <span v-if="getClientPhone">Tel: {{getClientPhone}}<br></span>
                                                        <span v-if="getClientEmail">Email: {{getClientEmail}}<br></span>
                                                    </td>
                                                </tr>
                                            </table>
                                            <table  width="100%" border="0" :class="isA5Format ? 'a5format' : 'a4format'" style="padding: 0; margin-right: -10px; margin-bottom: -5px; float: right">
                                                <tr align="right">
                                                    <td align="right" >
                                                        <h4>{{invoicePrintLabel}}</h4>
                                                    </td>
                                                </tr>
                                            </table>
                                            <table class="table table-bordered" :class="isA5Format ? 'a5format' : 'a4format'" border="1" width="100%" style="border-collapse: collapse; margin-right: 2%;">
                                                <tr align="left">
                                                    <th>Data</th>
                                                    <th>Funcionário</th>
                                                    <th>Moeda</th>
                                                    <th>Pág.</th>
                                                </tr>
                                                <tr>
                                                    <td>{{selectedReceipt.created_at | formatDate}}</td>
                                                    <td>{{getWhoRegisteredName}}</td>
                                                    <td>{{getCurrency}}</td>
                                                    <td>1/1</td>
                                                </tr>
                                            </table>
                                            <br><br>

                                            <table class="table table-bordered" :class="isA5Format ? 'a5format' : 'a4format'" border="1" width="100%" style="border-collapse: collapse; margin-right: 2%;">
                                                <tr>
                                                    <th align="left">Documento</th>
                                                    <th align="left">Número</th>
                                                    <th align="left">Data Emissão</th>
                                                    <th align="right">Valor Orig.</th>
                                                    <th align="right">Pendent</th>
                                                    <th align="right">Pago</th>
                                                </tr>
                                                <tr v-for="invoice in invoices" :key=invoice.id>
                                                    <td>Factura</td>
                                                    <td>{{invoice.code}}/{{invoice.series}}</td>
                                                    <td align="left">{{invoice.emission_date | formatDate}}</td>
                                                    <td align="right">{{invoice.total_value | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                                                    <td align="right">{{invoice.pivot.pendent_value_invoice | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                                                    <td align="right">{{getTotalPaid(invoice) | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                                                </tr>
                                            </table>
                                            <br><br>


                                            <v-flex xs12>
                                                <br><br>
                                                <!--<span style="padding-bottom: 0; font-size: 11px;">Tributo especial unificado (TEU)</span>-->
                                                <!--<v-divider></v-divider>-->
                                            </v-flex>
                                            <table class="table table-bordered" border="0" style="padding-top: 0; width: 100%; border-collapse: collapse; margin: 5px">
                                                <tr>
                                                    <td style="width: 60%; padding: 0; vertical-align: top;">
                                                        <table class="table table-bordered" border="0" width="100%" style="border-collapse: collapse; padding: 0;">
                                                        </table>
                                                    </td>

                                                    <td style="width: 20%; padding: 0">
                                                        <v-divider style="margin-right: 10px; padding-left: 20px"></v-divider>
                                                        <table class="table table-bordered" :class="isA5Format ? 'a5format' : 'a4format'" border="0" width="100%" style="border-collapse: collapse; border-top: none; margin-right: 2%;">
                                                            <!--<tr>-->
                                                                <!--<td align="left" style="padding-left: 20px;">Sub Total</td>-->
                                                                <!--<td align="right" style="padding-right: 10px;">30.000,00</td>-->
                                                            <!--</tr>-->
                                                            <tr>
                                                                <!--<td align="right" ><b>Total:</b></td>-->
                                                                <td align="right" ><b>Total: </b> {{getTotal | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </table>

                                            <!--<v-flex xs12 >-->
                                                <!--<p style="font-size: 10px;" :style="{'margin-top': getPaddingTop + 'px'}">Tributo especial unificado (TEU) nos termos da lei da alínea 3 do artigo nr.28 Decreto-lei nr.70/VIII/2014 de Agosto de 2014.</p>-->

                                                <!--<v-divider></v-divider>-->
                                            <!--</v-flex>-->

                                            <!--<v-flex shrink>-->
                                                <!--<p style="font-size: 11px;">Processado pelo programa <b>NHA FATURA</b> licenciado pelo contribuinte./ &copy;<b>Laciftech</b></p>-->
                                            <!--</v-flex>-->


                                            <!--Footer-->
                                            <div style="position: absolute; left: 0%; top: 94%; margin-left: 30px">
                                                <div style="position: relative; left: 0%; bottom: 6%">
                                                    <v-flex xs12>
                                                        <p style="margin-bottom: 10px"
                                                           :style="[isA5Format ? {'font-size': '9px'} : {'font-size':'11px'}]"
                                                        >Tributo especial unificado (TEU) nos termos da lei da alínea 3 do artigo nr.28 Decreto-lei nr.70/VIII/2014 de Agosto de 2014.</p>
                                                        <v-divider></v-divider>
                                                    </v-flex>
                                                    <v-flex shrink>
                                                        <p style="margin-top: 2px"
                                                           :style="[isA5Format ? {'font-size': '10px'} : {'font-size':'11px'}]">
                                                            Processado pelo programa <b>NHA FATURA</b> licenciado pelo contribuinte./ &copy;<b>Laciftech</b></p>
                                                    </v-flex>
                                                </div>
                                            </div>

                                        </div>
                                    </v-card>
                                </v-flex>

                            </v-flex>

                            <!--Side Buttons-->
                            <v-flex xs12 sm12 md3 lg2 style="margin-top: 25px">
                                <v-flex mx-2 xs12>
                                    <v-btn block :loading="downloadingOriginal" :disable="downloading2via"
                                           class="white--text" mx-2 grow color="indigo lighten-1" @click="downloadPDF(DOWNLOAD_ORIGINAL)">Baixar Original</v-btn>
                                </v-flex>

                                <v-flex mx-2 xs12>
                                    <v-btn block :loading="downloading2via" :disable="downloadingOriginal"
                                           class="white--text" mx-2 grow color="indigo lighten-1" @click="downloadPDF(DOWNLOAD_2VIA)">Baixar 2ª via</v-btn>
                                </v-flex>
                                <!--</v-layout>-->
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>


        </v-dialog>
    </div>
</template>

<script>
    // import {mapGetters} from 'vuex';
    import Vue from "vue";
    import {eventBus} from "../../main";
    import {mapGetters} from "vuex";
    import html2pdf from "html2pdf.js";

    export default {
        /* eslint-disable */

        beforeDestroy(){
            eventBus.$off('onReceiptPaperOpen');
        },

        data(){
            return{
                DOWNLOAD_ORIGINAL: 1,
                DOWNLOAD_2VIA: 2,

                loadingReceiptInvoices: false,
                invoices: [],
                invoicePrintLabel: "",

                downloadingOriginal: false,
                downloading2via: false,
            }
        },

        props:{
            isA5Format: {
                type: Boolean,
                default: false,
            }
        },

        methods:{
            downloadPDF(option){
                if (option === this.DOWNLOAD_ORIGINAL){
                    this.invoicePrintLabel = 'Original';
                    this.downloadingOriginal = true;
                }else if(option === this.DOWNLOAD_2VIA){
                    this.invoicePrintLabel = '2ª via';
                    this.downloading2via = true;
                }
                setTimeout(() => {
                    this.downloadPDFWorker();
                }, 200);

            },

            downloadPDFWorker() {
                const el = this.$refs.factura;

                let opt = {
                    margin:       0,
                    filename:     this.getFileName,
                    image:        { type: 'jpeg', quality: 1 },
                    html2canvas:  { scale: 2 },
                    jsPDF:        { unit: 'in', format: this.isA5Format ? 'a5' : 'a4', orientation: 'portrait' },
                    pdfCallback: this.pdfCallback()
                };

                let pdf = html2pdf().from(el).set(opt);
                pdf.save();
            },


            pdfCallback() {
                // alert("finished downloading")
                this.downloadingOriginal = false;
                this.downloading2via = false;
            },

            getEmail(json){
                try{
                    return json[0].email;
                }catch (e) {
                    return ""
                }
            },

            onFormModalOpened(){
                if(!this.showReceiptPaperModal) return; //proceed only if the model was open, not closed

                this.fetchReceiptInvoices();
                this.invoicePrintLabel = "Original";

            },

            fetchReceiptInvoices(){
                this.loadingReceiptInvoices = true;
                try{
                    Vue.axios.get('receipt/invoices/'+this.selectedReceipt.id)
                        .then(response => {
                            this.consoleLog(response);
                            if(!response.data.success){
                                // vm.showSnackBar('Erro ao atualizar cliente', 'error');
                                return;
                            }
                            this.invoices = response.data.response.invoice;
                            this.selectedInvoice = this.invoices[0];

                            // let settings = response.data.response.invoice.sell.company.settings;
                            // this.isA5Format = settings[0].invoice_receipt_format === "A5"


                        }).catch(error => {
                        this.consoleLog(error);
                        // vm.showSnackBar('Ocorreu um erro ao atualizar cliente', 'error');
                    }).finally( ()=> {
                        this.company_modal_loading = false;
                        this.loadingReceiptInvoices = false;
                        // this.loading_modal = false;
                    });
                }catch (e) {
                    this.consoleLog(e);
                }
            },

            getTotalPaid(myInvoice){
                let res = 0;
                for(let i=0; i<myInvoice.payments.length; i++){
                    // if(myInvoice.payments[i].invoice_receipt.receipt_id === this.selectedReceipt.id)
                    res += myInvoice.payments[i].value;
                }
                return res;
                // return this.selectedInvoice.total_value - this.selectedInvoice.pendent_value;
            },

            getCompany(){
                let res = '';
                try{
                    res = this.selectedInvoice.sell.company;
                    res = !res ? this.selectedCompany : res;
                }catch (e) {
                    res = this.selectedCompany;
                }
                return res;
            },

            getClient(){
                let res = '';
                try{
                    res = this.selectedInvoice.sell.client;
                    res = !res ? this.selectedClient : res;
                }catch (e) {
                    res = this.selectedClient;
                }
                return res;
            },

            getPhone(json){
                let mobile_phone = '', phone = '';
                try{
                    mobile_phone = json[0].mobile_phone;
                    phone = json[0].phone;

                    if(phone === null) phone = '';
                    if(mobile_phone === null) mobile_phone = '';
                }catch (e) {return ""}

                if(mobile_phone && phone)
                    return phone+" / "+mobile_phone;
                else if(!mobile_phone && !phone)
                    return '';
                else
                    return phone+""+mobile_phone;

            },

            getNibFormated(nib, nib_name){
                let nibRes = '';
                // if(nib_name){
                //     nibRes = "Nib_"+nib_name+": ";
                // }else { nibRes = "Nib: ";}
                //
                // if(nib){
                //     nibRes += nib;
                // }else { nibRes="";}

                nibRes = nib_name ? "Nib_"+nib_name+": " : "Nib: ";

                return nib ? nibRes += nib : '';

                // return nibRes;
            },

            close(){
                this.showReceiptPaperModal = false;
            },
        },

        watch:{
            showReceiptPaperModal(){
                this.onFormModalOpened();
            }
        },

        computed: {
            ...mapGetters([
                'loggedUser',
                'getToken',
            ]),
            showReceiptPaperModal: {
                get() {
                    return this.$store.getters.getShowReceiptPaperModal;
                },
                set(value) {
                    this.$store.dispatch('setShowReceiptPaperModal', value);
                }
            },
            selectedReceipt: {
                get() {
                    return this.$store.getters.getSelectedReceipt;
                },
                set(value) {
                    this.$store.dispatch('setSelectedReceipt', value);
                }
            },
            selectedInvoice: {
                get() {
                    return this.$store.getters.getSelectedInvoice;
                    // return 'qwe';
                },
                set(value) {
                    this.$store.dispatch('setSelectedInvoice', value);
                }
            },
            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },

            isReceiptCanceled(){
                // this.consoleLog('isReceiptCanceled: ', this.selectedReceipt);
                return this.selectedReceipt.deleted_at != null;
            },

            //Used to make footer stick at the bottom
            getPaddingTop(){
                const padding = 30;
                let extraPadding = 0;

                const maxPaddingMultiplier = 9;
                let quant = maxPaddingMultiplier - this.invoices.length;
                return quant * padding + extraPadding - 7;
            },

            getAlreadyPaid(){
                return this.selectedInvoice.total_value - this.selectedInvoice.pendent_value;
            },

              getCurrency(){
                try {
                    return this.selectedInvoice.sell.type_currency.name;
                }catch (e) {
                    return '$$$';
                }
            },

            getCompanyLogo(){
                let res = '';
                // return 'images/logo_lacif4.png';
                try{
                    res = this.loggedUser.group.company.image_path;
                }catch (e) { /*Do nothing*/}

                return res;
            },

            getNif(){
                let res = '';
                try{
                    res = this.getCompany().nif;
                }catch (e) {/*Do nothing*/}

                return res;
            },
            getLocation(){
                let res = '';
                try{
                    res = 'Cabo Verde ('+this.getCompany().city.name+')';
                }catch (e) {/*Do nothing*/}

                return res;
            },
            getNib(){
                let res = '';
                try{
                    res = this.getCompany().nib_bi;
                }catch (e) {/*Do nothing*/}
                return res;
            },

            getCompanyEmail(){
                try{
                    let json = JSON.parse(this.getCompany().contacts_json);
                    return json[0].email;
                }catch (e) { return ""}
            },

            getPrimaryNib(){
                let nib = '', nib_name = '';
                try{
                    try { nib = this.selectedInvoice.sell.company.nib_bi; }catch (e) { /*Do nothing*/ }
                    try { nib_name = this.selectedInvoice.sell.company.nib_bi_name; }catch (e) { /*Do nothing*/ }
                    return this.getNibFormated(nib, nib_name);
                }catch (e) { return ''; }
            },
            getSecondNib(){
                let nib = '', nib_name = '';
                try{
                    try { nib = this.selectedInvoice.sell.company.nib_bi2; }catch (e) { /*Do nothing*/ }
                    try { nib_name = this.selectedInvoice.sell.company.nib_bi2_name; }catch (e) { /*Do nothing*/ }
                    return this.getNibFormated(nib, nib_name);
                }catch (e) { return ''; }
            },

            getCompanyName(){
                try{
                    return this.getCompany().name;
                }catch (e) {
                    return '';
                }
            },

            getClientName(){
                try{
                    return this.getClient().name;
                }catch (e) {
                    return '';
                }
            },

            getClientNif(){
                let res = '';
                try {
                    res = this.getClient().nif;
                }catch (e) {
                    return '';
                }
                return res ? res : 'indefinindo';
            },

            getWhoRegisteredName(){
                try{
                    return this.selectedReceipt.user.name;
                }catch (e) {
                    return '';
                }
            },


            getClientCity(){
                try{
                    return this.getClient().city.name;
                }catch (e) {
                    return '';
                }

            },

            getCompanyPhone(){
                try{
                    let json = JSON.parse(this.getCompany().contacts_json);
                    return this.getPhone(json);
                }catch (e) { return ""}
            },

            getCompanyAddress(){
                try{
                    return "Endereço: "+this.getCompany().address + ', '+this.getCompany().city.name;
                }catch (e) {
                    return "";
                }
            },

            getCompanyNif(){
                try{
                    return this.getCompany().nif;
                }catch (e) {
                    return '';
                }
            },

            getClientPhone(){
                try {
                    let phone = this.getPhone(JSON.parse(this.getClient().contacts_json));
                    this.consoleLog('Phone: '+phone);
                    return phone;
                }catch (e) { return ''; }

            },

            getClientEmail(){
                try{
                    let email = this.getEmail(JSON.parse(this.getClient().contacts_json));
                    this.consoleLog('Email: '+email);
                    return email;
                }catch (e) { return ""}
            },



            getTotal(){
                let total = 0;
                // if(!this.selectedReceipt.payments) return -1;
                // for(let i=0; i<this.selectedReceipt.payments.length; i++){
                //     total += this.selectedReceipt.payments[i].value;
                // }
                // return total;
                for(let i=0; i<this.invoices.length; i++){
                    let invoice = this.invoices[i];
                    for(let j=0; j<invoice.payments.length; j++){
                        // if(invoice.payments[i].invoice_receipt.receipt_id === this.selectedReceipt.id)
                        total += invoice.payments[j].value;
                    }
                }
                return total;
            },

            getFileName(){
                return 'Recibo_'+this.selectedReceipt.code+''+this.selectedReceipt.series+'.pdf'
            },
        }
    }
</script>

<style scoped>

    table.a5format, .a5format tr, .a5format th, .a5format td{
        border-color: LightGray;
        border-left: none;
        border-right: none;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 11px;
    }

    table.a4format, .a4format tr, .a4format th, .a4format td{
        border-color: LightGray;
        border-left: none;
        border-right: none;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 14px;
    }


    table th{
        height: 30px;
    }

    table td{
        height: 25px;
    }

    #footer {
        position: fixed;
        bottom: 0;
        font-size: 11px;

        /*margin-top: 1mm;*/
    }

    .samewidth{
        table-layout: fixed ;
        width: 100% ;
    }
</style>